<template lang="pug">
  div.p-3.document-card
    div(v-for="field in cardData")
      span.mt-2.font-weight-bold
        | {{ field.label }}:
      div(v-html="processContent(field.values[0])" v-if="typeof field.values[0] == 'string'")
      div(v-else)
        ul
          li(v-for="value in field.values")
            span.mt-2.font-weight-bold
              | {{ value.label }}:
            div(v-html="processContent(value.values[0])")
</template>

<script>
import mixins from 'common/mixins'
import { marked } from 'marked'

export default {
  name: 'resumen-ia-vue',
  props: {
    cardData: { type: Array, default: () => [] }
  },
  mixins: [mixins.translate],
  methods: {
    processContent(text) {
      if (typeof text != 'string')
        return ''

      return marked.parse(text)
    }
  }
}
</script>
